import React from "react";
import BaseCard from "../../../components/ui/BaseCard";
import BaseCheckbox from "../../../components/ui/BaseCheckbox";
import { useFormik } from "formik";
import useAuth from "../../../hooks/useAuth";
import { useParams } from "react-router-dom";
import {
  createDesignationPermissions,
  fetchAllPermissionsByDesignation,
} from "../../../services/api/designation";
import { useMutation, useQuery } from "@tanstack/react-query";
import { ModuleType } from "../../../utils/enum";
import { getDesignationPermissionsByModule } from "../../../utils/getDesignationPermissionsByModule";

const GeneralPermissions = ({
  designationPermissions,
  designationId,
  refetchAllPermissionsByDesignation,
}) => {
  const engineerSkillsSetPermissions = getDesignationPermissionsByModule(
    designationPermissions,
    ModuleType.ENGINEER_SKILLS_SET,
  );

  const {
    isPending: isCreateDesignationPermissionsApiLoading,
    error: isCreateDesignationPermissionsApiError,
    mutateAsync: createDesignationPermissionsMutation,
  } = useMutation({
    mutationFn: createDesignationPermissions,
    enabled: false,
  });

  const formik = useFormik({
    initialValues: {
      ENGINEER_SKILLS_SET: {
        isRead: engineerSkillsSetPermissions.hasReadAccess,
        isWrite: engineerSkillsSetPermissions.hasWriteAccess,
        isUpdate: engineerSkillsSetPermissions.hasUpdateAccess,
        isDelete: engineerSkillsSetPermissions.hasDeleteAccess,
      },
    },
    onSubmit: (values) => {
      // Replace with your actual submit handler
      // handleConfirmApprovalButton(values);
    },
    validateOnChange: true,
    validateOnBlur: true,
    enableReinitialize: true,
    validateOnMount: true,
  });

  const handleEngineerSkillsSetPermissionsChange = async (e, value, module, permissionId) => {
    try {
      formik.setFieldValue(e.target.name, e.target.checked);
      const payload = {
        ...formik.values.ENGINEER_SKILLS_SET,
        [value]: e.target.checked,
        module,
        designationId: +designationId,
        permissionId,
      };

      await createDesignationPermissionsMutation(payload);
      await refetchAllPermissionsByDesignation();
    } catch (error) {}
  };

  return (
    <BaseCard elevation={0} className="p-5 rounded-lg">
      <div className="border-b pb-4">
        <p className="text-dark text-base font-normal mb-2">Skills/Qualifications's verification</p>
        <div className="grid grid-cols-5">
          <BaseCheckbox
            label="Allow Engineer Skills/Qualifications's access"
            name="ENGINEER_SKILLS_SET.isWrite"
            checked={formik.values.ENGINEER_SKILLS_SET.isWrite}
            onChange={(e) =>
              handleEngineerSkillsSetPermissionsChange(
                e,
                "isWrite",
                ModuleType.ENGINEER_SKILLS_SET,
                engineerSkillsSetPermissions.permissionId,
              )
            }
          />
        </div>
      </div>
    </BaseCard>
  );
};

export default GeneralPermissions;
